<template>
	<div style="background-color: #fff;height: 100vh;padding: 10px;">
		<div class="testchoice">
			<div class="testchoicetop flex">
				<el-progress :text-inside="true" text-color="#fff" :stroke-width="24" define-back-color="#fff" :percentage="presstext" status="success"></el-progress>
				<p class="testchoicetopright1">
					第
					<span>{{ isactive }}</span>
					/共
					<span>{{ textslist.length }}</span>
					题
				</p>
				<div class="testchoicetopright2">
					{{ Math.floor(seconds / 3600) < 10 || Math.floor(seconds / 3600) == 0 ? '0' + Math.floor(seconds / 3600) : Math.floor(seconds / 3600) }}:{{
						Math.floor((seconds % 3600) / 60) == 0 || Math.floor((seconds % 3600) / 60) < 10
							? '0' + Math.floor((seconds % 3600) / 60)
							: Math.floor((seconds % 3600) / 60)
					}}:{{ seconds % 60 < 10 || seconds % 60 == 0 ? '0' + (seconds % 60) : seconds % 60 }}
				</div>
			</div>

			<div class="testchoicebottom">
				<div class="flex testchoicebotttitle" v-if="examineobj.id !== 1">
					<span>题目数量</span>
					<el-select v-model="textvalue" placeholder=""><el-option v-for="item in 100" :key="item" :label="item" :value="item"></el-option></el-select>
					<button style="background-color: #337ab7;" @click="getquestiontrein">重新出题</button>
				</div>
				<div class="testchoicebottcontent">
					<div class="flex">
						<p class="testchoicefont flex" style="align-items: center;">
							<span style="margin-right: 10px;background-color: #337ab7;color: #fff;padding: 0 10px;border-radius: 5px;">
								{{ typechhioce(singletopic.SQT_GUID) }}
							</span>
							第
							<span>{{ isactive }}</span>
							题、
						</p>
						<p class="flex" style="align-items: center;justify-content: center;font-size: 14px;">{{ singletopic.SQB_Question }}。</p>
					</div>

					<div
						v-for="(item, index) in singletopic.Questionoptions"
						:key="item.SQO_GUID"
						@click="changetexts(item, index)"
						class="testchoiabc flex"
						style="margin:20px;border: 1px solid;border-radius: 3px;padding: 5px 10px;"
					>
						<!-- <input type="radio" v-model="singletopic.isradio" :name="singletopic.SQT_GUID"/> -->
						<div
							style="width: 20px;height: 20px;border-radius: 50%;border: 1px solid;"
							:class="{ scussce: item.isscusserr == 1, error: item.isscusserr == 2, info: item.isscusserr == 3 }"
						></div>
						<p style="margin-left: 10px;font-size: 16px;">{{ item.isletter }}、{{ item.SQO_OptionName }}</p>
					</div>
				</div>

				<div class="testlis flex">
					<div class="testlisleft flex">
						<p v-if="this.examineobj.id !== 1">
							答对：
							<span style="color:#5cb85c ;">{{ scusstext }}题</span>
						</p>
						<p v-if="this.examineobj.id !== 1">
							答错：
							<span style="color:red ;">{{ errstext }}题</span>
						</p>
						<p v-if="this.examineobj.id !== 1">
							正确率：
							<span style="color:#000 ;">{{ accuracy }}%</span>
						</p>
					</div>
					<div class="testlisright flex">
						<p title="提交多选题" v-if="singletopic.SQT_GUID == '4EBE5A8F10644FBF8FE61151567F90A3' && isdxbtn" style="background-color: #49b6d6;" @click="confirmsub">
							确认提交
						</p>
						<p style="background-color: #d3a374;" @click="previous">上一题</p>
						<p style="background-color: #d3a374;" @click="latter">下一题</p>
						<p style="background-color: #6bb36b;" @click="backtest">返回学习</p>
					</div>
				</div>
			</div>
			<div class="collapses">
				<el-collapse v-model="activeNames" @change="handleChange">
					<el-collapse-item :title="collapsetitle" name="1">
						<div class="flex" style="align-items: center;flex-wrap: wrap;">
							<div
								v-for="(item, index) in textslist"
								class="flex"
								style="cursor: pointer;margin: 10px;width: 30px;height: 30px;border: 1px solid #ccc;justify-content: center;align-items: center;"
								@click="changetext(index + 1)"
								:class="{ scusss: item.isscusserr == 1, error: item.isscusserr == 2 }"
							>
								<!-- :class="{'scusss'}" -->
								{{ index + 1 }}
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</div>
	</div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue';

import { getQuestionRandomTraining } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	data() {
		return {
			seconds: 0,
			collapsetitle: '展开答题卡',
			textvalue: 20,
			activeNames: ['展开答题卡'],
			examineobj: {},
			textslist: [],
			singletopic: {},
			isactive: 1,
			isdxbtn: false
		};
	},
	computed: {
		presstext() {
			if (this.textslist.length > 0) {
				let presslist = this.textslist.map(itm => itm.ischioces == true).filter(Boolean);
				// console.log(presslist,presslist.length)
				let nowpress = (presslist.length / this.textslist.length) * 100;
				// console.log(nowpress)
				return parseInt(nowpress);
			} else {
				return 0;
			}
		},
		scusstext() {
			let isscusserr = this.textslist.filter(itm => itm.isscusserr == 1);
			// console.log(isscusserr.length)
			return isscusserr.length;
		},
		errstext() {
			let isscusserr = this.textslist.filter(itm => itm.isscusserr == 2);
			// console.log(isscusserr.length)
			return isscusserr.length;
		},
		accuracy() {
			let isscusserr = this.textslist.filter(itm => itm.isscusserr == 1);
			let acy = (isscusserr.length / this.textslist.length) * 100;
			return parseFloat(acy.toFixed(2));
		}
	},
	methods: {
		backtest() {
			this.$router.go(-1);
		},
		typechhioce(ty) {
			if (ty == '677E84ABA24746228F2957B26C25347E') {
				return '单选题';
			} else if (ty == '4EBE5A8F10644FBF8FE61151567F90A3') {
				return '多选题';
			} else {
				return '判断题';
			}
		},

		changetexts(itm, idx) {
			let textslist = JSON.parse(JSON.stringify(this.textslist));
			if (this.singletopic.SQT_GUID !== '4EBE5A8F10644FBF8FE61151567F90A3') {
				// 单选和判断
				if (!this.singletopic.ischioces) {
					if (itm.SQO_IsAnswer) {
						this.singletopic.Questionoptions[idx].isscusserr = 1;
						this.singletopic.isscusserr = 1;
					} else {
						this.singletopic.Questionoptions[idx].isscusserr = 2;
						this.singletopic.isscusserr = 2;
					}
					this.singletopic.ischioces = true;

					textslist[this.isactive - 1] = this.singletopic;

					this.textslist = textslist;
				}
			} else {
				// 多选
				if (!this.singletopic.ischioces) {
					this.isdxbtn = true;
					if (this.singletopic.Questionoptions[idx].isscusserr == 0) {
						this.singletopic.Questionoptions[idx].isscusserr = 3;
					} else {
						this.singletopic.Questionoptions[idx].isscusserr = 0;
					}
				}
			}
		},
		confirmsub() {
			let textslist = JSON.parse(JSON.stringify(this.textslist));
			this.singletopic.Questionoptions.forEach(item => {
				if (item.isscusserr == 3) {
					if (item.SQO_IsAnswer) {
						item.isscusserr = 1;
						// console.log('我选择是对的')
					} else {
						item.isscusserr = 2;
						// console.log('我选择是错的')
					}
				} else {
					item.isscusserr = 2;
				}
			});
			// console.log(this.singletopic.Questionoptions,"多选确认")

			let scusslength = this.singletopic.Questionoptions.filter(ite => ite.SQO_IsAnswer);
			if (scusslength.every(val => val.isscusserr === 1)) {
				// console.log("所有元素都等于1");
				this.singletopic.isscusserr = 1;
			} else {
				// console.log("不是所有元素都等于1");
				this.singletopic.isscusserr = 2;
			}

			// console.log(scusslength)

			this.singletopic.ischioces = true;
			textslist[this.isactive - 1] = this.singletopic;

			this.textslist = textslist;
		},
		// 上一题下一题
		previous() {
			// console.log(this.isactive)
			if (this.isactive > 1) {
				this.isactive -= 1;
				this.singletopic = this.textslist[this.isactive - 1];
				// console.log(this.isactive)
			}
		},
		latter() {
			if (this.isactive < this.textslist.length) {
				this.isactive += 1;
				this.singletopic = this.textslist[this.isactive - 1];
				// console.log(this.isactive)
			}
		},
		changetext(i) {
			this.isactive = i;
			this.singletopic = this.textslist[this.isactive - 1];
		},

		handleChange(val) {
			// console.log(val);
		},
		getquestiontrein() {
			let questionobj = {
				pro_guid: this.examineobj.pro_guid,
				IL_GUID: this.examineobj.IL_GUID,
				PR_GUID: this.examineobj.PR_GUID,
				SQT_GUID: '',
				QNum: this.textvalue
			};
			getQuestionRandomTraining(questionobj).then(res => {
				this.textslist = res.data.data;
				let chiocelist = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
				this.textslist.forEach(item => {
					item.ischioces = false;
					item.isscusserr = 0;

					item.Questionoptions.forEach((itm, index) => {
						itm.isletter = chiocelist[index];
						itm.isletterchoice = '';
						itm.isscusserr = 0;
					});
				});

				// console.log(this.textslist)
				this.singletopic = this.textslist[this.isactive - 1];
				this.isactive = 1;
				this.changetext(1);
				// this.singletopic.isradio = false
			});
		},
		init() {
			if (this.examineobj.id == 2) {
				this.getquestiontrein();
			} else if (this.examineobj.id == 3) {
				this.getquestiontx();
			}
		},
		getquestiontx() {
			this.textvalue = this.$route.query.radionum;

			let sqtguid = this.$route.query.SQT_GUID;

			let PracticeMode = this.$route.query.PracticeMode;

			let questionobj = {
				pro_guid: this.examineobj.pro_guid,
				IL_GUID: this.examineobj.IL_GUID,
				PR_GUID: this.examineobj.PR_GUID,
				SQT_GUID: sqtguid,
				QNum: this.textvalue,
				PracticeMode: PracticeMode
			};
			// console.log(questionobj)
			getQuestionRandomTraining(questionobj).then(res => {
				this.textslist = res.data.data;
				let chiocelist = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
				this.textslist.forEach(item => {
					item.ischioces = false;
					item.isscusserr = 0;

					item.Questionoptions.forEach((itm, index) => {
						itm.isletter = chiocelist[index];
						itm.isletterchoice = '';
						itm.isscusserr = 0;
					});
				});

				// console.log(this.textslist)
				this.singletopic = this.textslist[this.isactive - 1];
			});
		}
	},
	mounted() {
		// console.log(this.$route);
		this.examineobj = this.$route.query;

		this.init();
	},

	created() {
		AppOptions.appEmpty = true;
		setInterval(() => {
			this.seconds++;
		}, 1000);
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	}
};
</script>

<style scoped lang="less">
.collapses {
	// height: 100px;
	padding: 0 20px;
	margin-top: 20px;

	.scusss {
		background-color: #4fee74;
		color: #fff;
	}

	.error {
		background-color: #ee0000;
		color: #fff;
	}
}

.testlis {
	justify-content: space-between;

	.testlisleft {
		padding-left: 40px;
		font-size: 16px;
		p {
			margin: 10px;
		}
	}

	.testlisright {
		margin-right: 40px;
		p {
			cursor: pointer;
			margin: 0 10px;
			padding: 0 10px;
			border-radius: 10px;
			height: 30px;
			line-height: 30px;
			color: #fff;
		}
	}
}

.testchoice {
	width: 1300px;
	min-width: 1300px;
	margin: 0 auto;
	border: 1px solid #ccc;
	border-radius: 10px;
	// padding:0 20px;
	box-sizing: border-box;
	.testchoicetop {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background-color: #000;
		color: #fff;
		align-items: center;
		padding-left: 10px;
		border-radius: 5px;

		/deep/ .el-progress {
			width: 80%;
		}

		.testchoicetopright1 {
			margin-left: 10px;
		}

		.testchoicetopright2 {
			padding-left: 20px;
			margin-left: 30px;
			font-size: 18px;
			border-left: 2px solid red;
			// color: red;
		}
	}
}

.testchoiabc:hover {
	cursor: pointer;
	background: #f5f5f5;

	p {
		color: #4fee74;
	}
}

.testchoicebottom {
	// padding: 0 40px;

	.testchoicebottcontent {
		padding-left: 60px;

		.info {
			background-color: #a7a0aa;
			margin: 0 !important;
		}

		.scussce {
			background-color: #4fee74;
			margin: 0 !important;
		}

		.error {
			background-color: #ee0000;
			margin: 0 !important;
		}

		.currentchoice {
			background-color: #4fee74;
			color: #fff;
		}

		.testchoicefont {
			font-size: 16px;
			color: #000;
			font-weight: 600;
		}
	}

	.testchoicebotttitle {
		align-items: center;
		padding-left: 20px;
		margin-top: 20px;
		margin-bottom: 20px;
		border-bottom: 1px solid #ccc;
		padding-bottom: 20px;

		button {
			padding: 5px 10px;
			color: #fff;
		}

		span {
			margin-right: 10px;
		}

		/deep/ .el-select {
			width: 80px;
			margin-right: 20px;
			/* selecte 框的高度设置，默认是 40px*/
			.el-input__inner {
				height: 20px;
			}
			/* 下面设置右侧按钮居中 */
			.el-input__suffix {
				top: 0px;
			}
			.el-input__icon {
				line-height: inherit;
			}
			.el-input__suffix-inner {
				display: inline-block;
			}
		}
	}
}

.flex {
	display: flex;
}

.fley {
	display: flex;
	flex-direction: column;
}
</style>
